// extracted by mini-css-extract-plugin
export var hidden = "_52-1";
export var leftPanel = "_52-2";
export var readonlyInspector = "_52-3";
export var rightPanel = "_52-0";